// extracted by mini-css-extract-plugin
export var downArrow = "_a7-0";
export var infoTooltipIcon = "_a7-3";
export var label = "_a7-1";
export var optionCard = "_a7-4";
export var upArrow = "_a7-2";